import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeadersService, environment } from '@perval/shared';
import { firstValueFrom } from 'rxjs';
import { Utilisateur } from '../models/utilisateur';

@Injectable({
  providedIn: 'root',
})
export class UtilisateurService {
  private readonly mainUrl = `${environment.baseApiUrl}/perval-utilisateurs`;

  constructor(
    private readonly http: HttpClient,
    private readonly httpHeadersServiceService: HttpHeadersService,
  ) {}

  public async createXNotUser(
    xnotUtilisateur: Utilisateur.XNot,
  ): Promise<void> {
    await firstValueFrom(
      this.http.post(
        `${this.mainUrl}/provisioning-xnot`,
        {
          organization: {
            code: xnotUtilisateur.organization.code,
            company_name: xnotUtilisateur.organization.name,
            line_1: xnotUtilisateur.organization.adressLine1,
            line_2: xnotUtilisateur.organization.adressLine2,
            line_3: xnotUtilisateur.organization.adressLine3,
            city: xnotUtilisateur.organization.city,
            postal_code: xnotUtilisateur.organization.postalCode,
            email: xnotUtilisateur.organization.email,
            phone: xnotUtilisateur.organization.phone,
          },
          user: {
            lastname: xnotUtilisateur.user.lastName,
            firstname: xnotUtilisateur.user.firstName,
            email: xnotUtilisateur.user.email,
            login: xnotUtilisateur.user.login,
          },
          order: {
            offer_id: xnotUtilisateur.order.offerId,
            is_replenishment: xnotUtilisateur.order.isReplenishment,
          },
        },
        {
          headers:
            await this.httpHeadersServiceService.getHeadersWithPervalContext(),
        },
      ),
    );
  }
}
